import { Paper } from '@material-ui/core';
import { useQuery } from '@apollo/react-hooks';
import React, { useEffect } from 'react';
import DetailedTable from '../../components/DetailedTable';
import { Loading } from '../../Loading';
import { TRANSFORM_SPEC_HISTORY } from '../graphQL/queries';
import { NetworkStatus } from '@apollo/client';

import _ from 'lodash';

const AuthContextDetailView = (props: any) => {
  const [formInfo, setFormInfo] = React.useState<any>({});

  useEffect(() => {
    const operationsList = _.filter(props.data || [], (o: any) => o.participantCode === props?.participantCode);
    setFormInfo(operationsList);
    _.keys(operationsList || []).forEach(key => {
      console.log('operationsList: ' + key);
    });
  }, []);

  const { loading, data, networkStatus } = useQuery<any, {}>(TRANSFORM_SPEC_HISTORY, {
    variables: {
      participantCode: props.participantCode,
      workflowCode: props.workflowCode,
      operationCode: props.operationCode,
      type: props.type,
      httpStatusCode: props.httpStatus
    },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });

  const subcolumns = [
    {
      title: 'Operations',
      field: 'operationCode'
    },
    {
      title: 'Auth Context',
      field: 'authContext'
    }
  ];

  return (
    <Paper variant="outlined">
      {loading || networkStatus === NetworkStatus.refetch ? (
        <Loading />
      ) : (
        <DetailedTable
          id={`TransformSpec-${props.participantCode}-${props.operationCode}-${props.type}`}
          title="Auth Context"
          data-id="authVontext"
          columns={subcolumns}
          data={formInfo || []}
          showSelection={false}
          showTitle={false}
          showToolbar={false}
          tableActions={[]}
          showPagination={true}
        />
      )}
    </Paper>
  );
};
export default AuthContextDetailView;
